<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-map-item-pin(
    :data-id="mapdata.id"
    v-if="show"
    :style="styleObject"
    :class="{active:active,hotoke:hotoke}"
    @mouseover="mouseover"
    @touchstart="touchstart"
    ref="root"
  )
    .l-map-item-pin__obj(:data-id="mapdata.id")
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-item-pin
  pos(0,0,10)
  cursor pointer
  transform-origin center bottom
  &__obj
    background-image url('~@/assets/images/ui-map-pin.png')
    background-size cover
    ^[0].hotoke &
      background-image url('~@/assets/images/ui-map-pin-hotoke.png')
    ^[0].active &
      transform scale(1.2)
    $w = 76px
    $h = 94px
    +pc()
      $rate = 0.5
      pos(-($w*$rate*0.42),-($h*$rate*0.85))
      wh($w*$rate,$h*$rate)
      transition transform 250ms $easeOutBack
      transform-origin center bottom
      ^[0]:hover &
        transform scale(1.2)
    +sp()
      $rate = 0.84
      pos(-($w*$rate*0.42),-($h*$rate*0.85))
      wh($w*$rate,$h*$rate)
      transition transform 250ms $easeOutBack
      transform-origin center bottom
</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted,onUnmounted,onBeforeUnmount,computed,watch,ref} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import LogoVue from "../logo/Logo.vue"
import ArticleIllustVue from '../article/ArticleIllust.vue'
import Util from '../../lib/util'

export default defineComponent({
  name:'MapItemPin',

  props:{
    maptype:{
      type:Number,
      default: 1
    },
    mapdata:{
      type:Object,
      default: function() {
        return {}
      }
    }
  },

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const root = ref(null)

    const show = computed(()=>{
      // console.log(store.ui.state.hotoke , props.mapdata.hotoke , store.ui.state.hotoke == props.mapdata.hotoke);
      if(store.ui.state.hotoke == props.mapdata.hotoke){
        return true
      } else {
        return false
      }
    })
    const styleObject = computed(()=>{
      const coordinate = props.mapdata.coordinate.split(",")
      return {
        left: coordinate[0] + 'px',
        top: coordinate[1] + 'px'
      }
    })
    const active = computed(()=>{
      if(store.ui.state.article.show){
        if(route.params.id == props.mapdata.id){
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    })
    const hotoke = computed(()=>{
      return props.mapdata.hotoke
    })

    // const click = ()=>{
    //   if(store.browser.state.responsive == 'pc'){
    //     //PCの時は直接詳細を開く
    //     router.push('/article/'+props.mapdata.id)
    //   } else {
    //     //SPの時は簡易情報をはさむ。
    //     store.ui.state.easyinfo.show = true
    //     store.ui.state.easyinfo.mapdata = props.mapdata
    //   }
    // }
    const preloadData = ()=>{
      //該当スポットを取得（まだデータ未取得の場合）
      if(!store.api.getSpotById(props.mapdata.id).id){
        store.api.initSpot(props.mapdata.id,true)
      }
      //サムネイル画像をプリロードしておく
      if(props.mapdata.thumbnail){
        const img = new Image()
        img.src = props.mapdata.thumbnail
      }
    }
    const mouseover = ()=>{
      if(store.browser.state.isTouch) return
      preloadData()
    }
    const touchstart = ()=>{
      if(!store.browser.state.isTouch) return
      preloadData()
    }

    const motionIn = (el,delay=0,callback=null)=> {
      delay += props.mapdata._order * store.ui.state.mapytypeMotionDelayTimeOne / 1000
      const countObject = store.api.state.countMapDataItem(props.maptype,'object')
      delay += countObject * store.ui.state.mapytypeMotionDelayTimeOne / 1000
      const tl = gsap.timeline()
      // tl.fromTo(
      //   el,
      //   {opacity:0,y:-40},
      //   {opacity:1,duration:0.01,ease:'linear',delay:delay,overwrite:false}
      // )
      tl.fromTo(
        el,
        {opacity:0,y:-30},
        {y:0,duration:0.6,opacity:1,delay:delay,ease:'back.out',overwrite:false,onComplete:()=>{
          if(callback) callback()
        }}
      )
    }
    const motionOut = (el,delay=0,callback=null)=> {
      gsap.to(
        el,
        {scale:0,duration:0.1,ease:'power2.in',onComplete:()=>{
          if(callback) callback()
        }}
      )
    }

    onMounted(async ()=>{
      if(root.value){
        let delay = (store.ui.state.hotoke ? store.ui.state.kumoMotionDurationAll : store.ui.state.mapytypeMotionDurationAll) / 1000
        if(store.ui.state.tutorial.through){
          delay = 0.3
        }
        if(store.ui.state.hotoke){
          delay += 0.7
        }
        if(!store.ui.state.init){
          await (async () => {
            for await (let i of Array(20)) {
              await Util.sleep(100)
              if(store.ui.state.init) break
            }
          })()
        }
        motionIn(root.value,delay)
      }
    })
    onBeforeUnmount(()=>{
      if(root.value){
        motionOut(root.value)
      }
    })

    const enter = (el, done)=> {
      motionIn(el,store.ui.state.kumoMotionDurationAll/1000 + 0.5,()=>{
        done()
      })
    }
    const leave = (el, done)=> {
      motionOut(el,()=>{
        done()
      })
    }

    return{
      show,
      styleObject,
      active,
      // click,
      hotoke,
      root,
      enter,
      leave,
      mouseover,
      touchstart,
      props
    }
  }
})
</script>
